// How the shared actions (src/features/<area>/) talk to a person on the DESKTOP: the browser's own
// alert / confirm / prompt, the PIN modal, the T&M cause picker, the remake dialogs, and the print
// dialog (and a new tab for Sales Order PDFs): exactly what the desktop pages always used, with the same arguments, so they behave as
// before (their tests pin the prompts word for word). The phone's twin: mobile/ui/phoneUi.js.
import pinPrompt from "../utils/pinPrompt";
import causePrompt from "../utils/causePrompt";
import openPdfInPrintDialog from "./queue/printPdf";
import { askTypedMinutes } from "../utils/tmAutoComplete";
import { remakeHoldChoice, remakeHeadsUp } from "../components/RemakeDialogs.jsx";
import { openPdfTab } from "./salesOrders/soPdf";
import stickLotPrompt from "../utils/stickLotPrompt";

export const desktopUi = Object.freeze({
  pin: (message, opts) => (opts === undefined ? pinPrompt(message) : pinPrompt(message, opts)),
  alert: (message) => { window.alert(message); },
  confirm: (message) => window.confirm(message),
  prompt: (message, defaultValue) => (defaultValue === undefined ? window.prompt(message) : window.prompt(message, defaultValue)),
  causePrompt: (opts) => causePrompt(opts),
  remakeHoldChoice: (hold) => remakeHoldChoice(hold),
  remakeHeadsUp: (preview, opts) => remakeHeadsUp(preview, opts),
  askTypedMinutes: (detail) => askTypedMinutes(detail),
  stickLots: (state) => stickLotPrompt(state),
  // Laser Start: the sales-order pallets and their beacons (loaded on first use: it brings the Find hook).
  palletBeacons: (opts) => import("../utils/palletBeaconsPrompt").then((m) => m.default(opts)),
  openPdf: (blob) => openPdfInPrintDialog(blob),
  // A PDF from the API in a new tab, printed (Sales Order labels and manifests).
  openPdfTab: (url, filename) => openPdfTab(url, filename),
});
